export { Table, TableBody } from "ics-ui-kit/components/table";
export { TableCell } from "./TableCell";
export { TableHead } from "./TableHead";
export { TableHeader } from "./TableHeader";
export { TableRow } from "./TableRow";
